module.exports = __webpack_public_path__ + "static/media/icon_199.2a2370dd.svg";